
export function selectSearchQuery(state) {
  return state.getIn(['app', 'search', 'query']);
}

export function selectPages(state) {
  return state.getIn(['app', 'search', 'pages']);
}
